import { BiSolidCameraPlus, BiBuildings, BiLogoMicrosoft, BiSolidBaguette, BiSolidBuildings } from "react-icons/bi";
import {
    BsBoxFill, BsFillPersonPlusFill, BsCameraVideoFill,
    BsCameraFill, BsFillKeyFill, BsFillFileEarmarkZipFill, BsFillImageFill,
    BsQuestionCircleFill, BsBoxArrowRight, BsFillPostcardFill,
    BsClipboard2PlusFill, BsFillPeopleFill, BsFillRocketTakeoffFill,
    BsPersonCircle, BsClockFill, BsWebcam, BsKanbanFill, BsFileArrowDown,
    BsFileEarmarkWord, BsBarChartFill, BsReceipt, BsMicFill, BsFolderCheck
} from "react-icons/bs";
import {
    ProfileManagementIcon, CompanyManagementIcon, ProjectManagementIcon,
    TaskManagementIcon, BrandIcon, CameraSettingsIcon, ErrorEmailIcon,
    UserPermissionsIcon, TimeLapseCameraIcon, HomeIcon,
    LiveCameraIcon,
    AICameraIcon
} from '../components/icons/CustomIcons';
import { TbBrandWindowsFilled } from "react-icons/tb";
import { FaMicrosoft } from "react-icons/fa6";

// import Profile from "../pages/auth/Profile"
import Login from "../pages/auth/Login"
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import Analytics from "../pages/dashboard/Analytics";
import FinalCopies from "../pages/document/FinalCopies";
import AudioToText from "../pages/AudioToText";
import Role from "../pages/permissions/Role"
import Profile from "../pages/auth/Profile";
import UserRole from "../pages/permissions/UserRole";
// import UserView from "../pages/users/View";
// import PackageView from '../pages/packages/View';

import ClientView from '../pages/clients/View';
import ClientCsv from '../pages/clients/ClientCsv';
import UserCsv from '../pages/users/UserCsv';
import UserManagementView from '../pages/users/View';
import ServiceView from '../pages/service/View';
import ServiceTaskView from '../pages/service/ServiceTaskView';
import WorkView from '../pages/works/View';
import WorkAssignForm from '../pages/works/AssignForm';
import MindMap from '../pages/works/MineMap';
import MoreInfo from '../pages/extra/MoreInfo';
// import ErrorMailView from '../pages/errschmail/ErrorMail';
// import UserPermissionView from '../pages/userperm/View';
import MessagesView from '../pages/chat/View';
import InvoiceView from '../pages/invoice/View';

// import ImageArchive from "../pages/archives/ImageArchive";


import TaskView from "../pages/tasks/View";
import Approval from "../pages/tasks/Approval";
import WorkAdminQueue from "../pages/works/WorkAdminQueue";
import RouteMap from "../pages/works/RouteMap";
import MyTaskView from "../pages/tasks/MyTask";

import MyLeaves from "../pages/attendance/MyLeaves";
import LeaveApprovals from "../pages/attendance/LeaveApprovals";
import AttendanceReport from "../pages/attendance/Report";
import MyAttendance from "../pages/attendance/MyAttendance";
import WorkingTimeSettings from "../pages/attendance/Settings";
// import CheckListForm from "../pages/tasks/CheckListForm";

import DocumentView from "../pages/document/View";
import DocumentForm from "../pages/document/Form";
import Documents from "../pages/document/Documents";
import FileUploader from "../pages/document/FileUpload";
import History from "../pages/document/History";
import DocumentHub from "../pages/document/DocumentHub";

import {
    HelpIcon, PackageIcon, PermissionsIcon,
} from "../components/icons/CustomIcons";
import { Project24, Usermangement24, Videoarchives24 as VideoArchives24, Imagearchives24 as ImageArchives24, Timelapsecamera24 } from "../components/icons/Icons";
import AuditLogs from "../pages/audit/AuditLogs";
import Appraisal from "../pages/dashboard/Appraisal";
import EmployeeRouteMap from "../pages/dashboard/EmployeeRouteMap";
import HelpView from "../pages/help/HelpView";


export const anonyMenus = [
    {
        to: "/",
        component: <Login />,
    },
    {
        to: "/login/",
        component: <Login />,
    },
    {
        to: "/forgot-password/",
        component: <ForgotPassword />,
    },
    {
        to: "/reset-password/",
        component: <ResetPassword />,
    },
    {
        to: "/dictate/",
        component: <AudioToText />,
    },

]
const iconColor = "#0f3968"
export const menus = [
    {
        icon: <HomeIcon variant="filled" color={iconColor} />,
        label: "Dashboard",
        to: "/",
        proxyto: [
            { to: "/dashbord/", component: <Dashboard /> },
            { to: "/profile/", component: <Profile /> }, /*profile is not in menu so setup in proxyto*/
            { to: "/more-info/", component: <MoreInfo /> },
        ],
        component: <Dashboard />,
        permission: "*",
    },

    {
        icon: <BsBarChartFill color={iconColor} />,
        label: "Analysis",
        to: "/analytics/",
        component: <Analytics />,
        permission: "*",
    },
    {
        icon: <BsFillPersonPlusFill color={iconColor} />,
        label: "Appraisal",
        to: "/appraisal/",
        component: <Appraisal />,
        permission: "*",
        proxyto: [
            { to: "/employee-timeline/:id", component: <EmployeeRouteMap /> },
        ]
    },

    {
        icon: <BsFileArrowDown color={iconColor} />,
        label: "File Upload",
        to: "/fileupload",
        component: <FileUploader />,
        permission: "*",
        hide: true
    },


    {
        icon: <CompanyManagementIcon variant="filled" color={iconColor} />,
        label: "Clients",
        to: "/clients/",
        component: <ClientView />,
        permission: "view_permission",
        owner: ["User", "Campany"],
        changeText: "My Company",
        proxyto: [
            { to: "/csv/", component: <ClientCsv /> },
        ],
        permission: "view_client",
    },

    {
        icon: <Project24 variant="filled" viewBox="0 0 24 24" color={iconColor} />,
        label: "Services",
        to: "/services/",
        component: <ServiceView />,
        permission: "view_service",

        proxyto: [
            { to: "/services-tasks/", component: <ServiceTaskView /> },
        ],
    },

    {
        icon: <PackageIcon size={24} variant="filled" color={iconColor} />,
        label: "Works",
        to: "/works/",
        component: <WorkView />,
        permission: "view_work",

        proxyto: [
            { to: "/work-assign/", component: <WorkAssignForm /> },
            { to: "/mind-map/", component: <MindMap /> },
            { to: "/work-axis/routemap/:id", component: <RouteMap /> }
        ],
    },
    {
        icon: <BsReceipt size={24} color={iconColor} />,
        label: "Invoices",
        to: "/invoices/",
        component: <InvoiceView />,
        permission: "view_invoice",
    },
    {
        icon: <PackageIcon size={24} variant="filled" color={iconColor} />,
        label: "Tasks",
        to: "/tasks/",
        component: <TaskView />,
        permission: "view_work",
        hide: true,

        proxyto: [
            { to: "/work-assign/", component: <WorkAssignForm /> },
        ],
    },
    {
        icon: <TaskManagementIcon size={24} variant="filled" color={iconColor} />,
        label: "Task Approvals",
        to: "/task-approvals/",
        component: <Approval />,
        permission: "can_approve_task",
        proxyto: [
            { to: "/work-admin-queue/", component: <WorkAdminQueue /> },
        ],
    },

    // {
    //     icon: <TaskManagementIcon size={24} variant="filled" color={iconColor} />,
    //     label: "Admin Queue",
    //     to: "/work-admin-queue/",
    //     component: <WorkAdminQueue />,
    //     permission: "view_work",
    // },

    {
        icon: <BsFileEarmarkWord size={24} color="gray" />,
        label: "Documents",
        to: "/repository/",
        component: <DocumentView />,
        permission: "*",
        hide: true,
        proxyto: [
            { to: "/repository/:id", component: <DocumentView /> },
            { to: "/commits/", component: <Documents /> },
            { to: "/repository/documents/:id", component: <Documents /> },
            { to: "/history/", component: <History /> },
            { to: "/final-copies/", component: <FinalCopies /> },
            {
                to: "/fileupload/", component: <FileUploader back={() => {
                    document.location.href = "#/repository/"

                }} />
            },
        ],
        permission: "view_work",
    },
    {
        icon: <BsFolderCheck size={24} color={iconColor} />,
        label: "Final Copies",
        to: "/final-copies/",
        component: <FinalCopies />,
        permission: "can_view_final_doc",
    },
    // {
    //     icon: <BsFileEarmarkWord size={24} color={iconColor} />,
    //     label: "AI Document Hub",
    //     to: "/document-hub/",
    //     component: <DocumentHub />,
    //     permission: "view_work",
    // },
    {
        icon: <Usermangement24 size={24} viewBox="0 0 24 24" variant="filled" color={iconColor} />,
        label: "Employees",
        to: "/user-management/",
        component: <UserManagementView />,
        permission: "view_user",
        proxyto: [
            { to: "/users-csv/", component: <UserCsv /> },
            { to: "/my-leaves/", component: <MyLeaves /> },
            { to: "/leave-approvals/", component: <LeaveApprovals /> },
            { to: "/attendance-report/", component: <AttendanceReport /> },
            { to: "/working-time-settings/", component: <WorkingTimeSettings /> },
        ],
    },
    {
        icon: <BsClockFill size={24} color={iconColor} />,
        label: "My Attendance",
        to: "/my-attendance/",
        component: <MyAttendance />,
        permission: "view_my_attendance",
    },
    {
        icon: <BsClockFill size={24} color={iconColor} />,
        label: "My Leaves",
        to: "/my-leaves/",
        component: <MyLeaves />,
        permission: "add_leaverequest",
        proxyto: [
            { to: "/messages/", component: <MessagesView /> },
        ],
    },
    {
        icon: <BsKanbanFill size={24} color={iconColor} />,
        label: "Leave Approvals",
        to: "/leave-approvals/",
        component: <LeaveApprovals />,
        permission: "change_leaverequest",
    },
    {
        icon: <BsBarChartFill size={24} color={iconColor} />,
        label: "Attendance Report",
        to: "/attendance-report/",
        component: <AttendanceReport />,
        permission: "view_attendance",
    },
    {
        icon: <CameraSettingsIcon size={24} color={iconColor} />,
        label: "Time Settings",
        to: "/working-time-settings/",
        component: <WorkingTimeSettings />,
        permission: "view_workingtimesetting",
    },
    // {
    //     icon: <TaskManagementIcon size={24} variant="filled" color={iconColor} />,
    //     label: "Invoices",
    //     to: "/invoices/",
    //     component: <InvoiceView />,
    //     permission: "view_user",
    // },

    {
        icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
        label: "Permissions",
        to: "/role/",
        component: <Role />,
        permission: "view_permission",
    },
    {
        icon: <UserPermissionsIcon size={24} variant="filled" color={iconColor} />,
        label: "Assign Roles",
        to: "/assign-role/",
        component: <UserRole />,
        permission: "view_permission",
    },
    {
        icon: <BsBarChartFill color={iconColor} />, // using a generic icon
        label: "Audit Logs",
        to: "/audit-logs/",
        component: <AuditLogs />,
        permission: "view_permission",
    },

    // {
    //     icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
    //     label: "More...",
    //     to: "/role/",
    //     component: <Role />,
    //     permission: "view_permission",
    //     submenus: [
    //         {
    //             icon: <PermissionsIcon size={24} variant="filled" color={iconColor} />,
    //             label: "Permissions",
    //             to: "/role/",
    //             component: <Role />,
    //             permission: "view_permission",
    //         },
    //         // {
    //         //     icon: <UserPermissionsIcon size={24} variant="filled" color={iconColor} />,
    //         //     label: "User <br/>Permission",
    //         //     to: "/user-permission/",
    //         //     component: <UserPermissionView />,
    //         //     permission: "view_permission",

    //         // },
    //         // {
    //         //     icon: <ErrorEmailIcon size={24} variant="filled" color={iconColor} />,
    //         //     label: "Schedule <br/>Error Mail",
    //         //     to: "/error-schedule/",
    //         //     component: <ErrorMailView />,
    //         //     permission: "view_permission",

    //         // },
    //         // {
    //         //     icon: <PackageIcon size={24} variant="filled" color={iconColor} />,
    //         //     label: "Package",
    //         //     to: "/packages/",
    //         //     component: <PackageView />,
    //         //     permission: "view_package",
    //         // },
    //     ]
    // },

    // {
    //     icon: <BiLogoMicrosoft size={24} color={iconColor} />,
    //     label: "Envelop Message",
    //     to: "/messages/",
    //     component: <MessagesView />,
    //     permission: "*",
    //     hide: true,
    // },
    // {
    //     icon: <BiLogoMicrosoft size={24} color={iconColor} />,
    //     label: "Envelop Message",
    //     to: "/notify/",
    //     component: <NotifyView />,
    //     permission: "*",
    //     hide: true,
    // },

    {
        icon: <HelpIcon size={24} variant="filled" color={iconColor} />,
        label: "Help",
        to: "/help/",
        component: <HelpView />,
        permission: "*",
    },
    {
        icon: <BsMicFill size={24} color={iconColor} />,
        label: "Dictation",
        to: "/dictate/",
        component: <AudioToText />,
        permission: "*",
    },
]